export const isRewardCapabilityActive = (value) => {
  if (value === true || value === 1) return true;

  const normalizedValue = String(value ?? "").trim().toLowerCase();
  return normalizedValue === "1" ||
    normalizedValue === "true" ||
    normalizedValue === "active";
};

export const getRewardCapabilities = ({
  clientEarnActive,
  clientBurnActive,
  cardMasterEarnActive,
  cardMasterBurnActive,
  product,
}) => {
  // Legacy mapping:
  // maxEarnPoints represents product Burn support/value.
  // minEarnPoints represents product Earn support/value.
  // Do not infer their purpose from the property names.
  const productSupportsEarn = Number(product?.minEarnPoints ?? 0) > 0;
  const productSupportsBurn = Number(product?.maxEarnPoints ?? 0) > 0;

  const effectiveEarn =
    isRewardCapabilityActive(clientEarnActive) &&
    isRewardCapabilityActive(cardMasterEarnActive) &&
    productSupportsEarn;
  const effectiveBurn =
    isRewardCapabilityActive(clientBurnActive) &&
    isRewardCapabilityActive(cardMasterBurnActive) &&
    productSupportsBurn;

  return {
    clientEarnActive: isRewardCapabilityActive(clientEarnActive),
    clientBurnActive: isRewardCapabilityActive(clientBurnActive),
    cardMasterEarnActive: isRewardCapabilityActive(cardMasterEarnActive),
    cardMasterBurnActive: isRewardCapabilityActive(cardMasterBurnActive),
    productSupportsEarn,
    productSupportsBurn,
    effectiveEarn,
    effectiveBurn,
  };
};

export const sanitizeRewardValues = ({
  effectiveEarn,
  effectiveBurn,
  earnPoints,
  burnPoints,
}) => ({
  // Undefined capability flags come from legacy CheckoutProvider consumers.
  // Only an explicit false should suppress values at the checkout boundary.
  earnPoints: effectiveEarn === false
    ? 0
    : Number(String(earnPoints || 0).replace(/,/g, "")),
  burnPoints: effectiveBurn === false
    ? 0
    : Number(String(burnPoints || 0).replace(/,/g, "")),
});
